<template>
    <label class="fac-checkbox" :class="design">
        <input
            v-model="checkedComputed"
            :id="id"
            :name="name"
            :disabled="disabled"
            type="checkbox"
            @change="onChange"
            :data-ui="dataUi || null"
        />
        <span class="label">{{ label }}</span>
    </label>
</template>
<script>
    export default {
        name: 'ui-checkbox',
        props: {
            /**
             * Referente ao id="" da tag input do checkbox.
             */
            id: {
                type: null,
                required: false,
                default: null
            },
            /**
             * Texto que vem ao lado do checkbox.
             */
            label: {
                type: String,
                required: false,
                default: ''
            },
            /**
             * Referente ao name="" da tag input do checkbox.
             */
            name: {
                type: String,
                required: false,
                default: ''
            },
            /**
             * Recebe as classes CSS de moficação do componente.
             */
            design: {
                type: String,
                required: false,
                default: ''
            },
            /**
             * Utilize para definir o estado do checkboxEstado inicial do componente
             */
            checked: {
                type: Boolean,
                required: false,
                default: false
            },
            /**
             * Utilize para desabilitar a ação do checkbox
             */
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            /**
			 * Define uma tag de teste para os testes integrados
			 * para o checkbox do componente
			 */
			dataUi: {
				type: String,
				required: false,
				default: ''
			},
        },

        computed: {
            /**
             * Computed property que controla a propriedade checked do input type checkbox
             * Obs.: quando utilizar o component checkbox, caso deseje que a propriedade
             * checked seja reativa, utilizar :checked.sync para passar a prop
             */
            checkedComputed: {
                get() {
                    return this.checked
                },
                set(value) {
                    this.$emit('update:checked', value)
                }
            }
        },

        methods: {
            onChange(event) {
                this.$emit('input', event.target.checked)
                this.$parent.$emit('checked', this.id)
            },
        },
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
